module.exports = __webpack_public_path__ + "img/photo.ab163773.png";